import axios from 'axios';

export default {
  namespaced: true, 
  state: {
    teamData: {},
    selectedYear: new Date().getFullYear(),
    dataLoadFailed: false,
  },
  mutations: {
    updateTeamData(state, teamData) {
      state.teamData = teamData;
      state.dataLoadFailed = false;
    },
    setSelectedYear(state, year) {
      state.selectedYear = year;
    },
    setDataLoadFailed(state, failed) {
      state.dataLoadFailed = failed;
    },
  },
  actions: {
    getTeamData({ commit, state }, year = null) {
      // Use provided year or current state year
      const targetYear = year || state.selectedYear;
      const currentYear = new Date().getFullYear();
      
      
      var currentUrl = window.location.href;
      var index = currentUrl.indexOf("/#/")

      // Build file path based on year
      var fileLocation;
      if (targetYear === currentYear) {
        fileLocation = "/teamData.json";
      } else {
        fileLocation = `/teamData${targetYear}.json`;
      }
      
      if (currentUrl.indexOf("localhost") > 0) {
        fileLocation = "/test" + fileLocation;
      }
      var url = currentUrl.slice(0, index) + fileLocation;

      axios
      .get(url)
      .then(results => commit('updateTeamData', results.data))
      .catch(error => {
        console.error('Error loading team data for year', targetYear, error);
        if (targetYear === currentYear) {
          // Current year data not available yet — show "coming soon"
          commit('updateTeamData', {});
          commit('setDataLoadFailed', true);
        } else {
          // Fallback to current year data if specific year fails
          this.dispatch('teamData/getTeamData', currentYear);
        }
      });
    },
    setYearAndLoadData({ commit, dispatch }, year) {
      commit('setSelectedYear', year);
      // Save to localStorage with timestamp
      const yearData = {
        year: year,
        timestamp: Date.now()
      };
      localStorage.setItem('hrd-selected-year', JSON.stringify(yearData));
      // Load data for the new year
      dispatch('getTeamData', year);
    },
    initializeYearFromStorage({ commit, dispatch }) {
      try {
        const stored = localStorage.getItem('hrd-selected-year');
        if (stored) {
          const yearData = JSON.parse(stored);
          const now = Date.now();
          const oneDay = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
          
          // Check if stored data is less than 24 hours old
          if (now - yearData.timestamp < oneDay) {
            commit('setSelectedYear', yearData.year);
            dispatch('getTeamData', yearData.year);
            return;
          } else {
            // Expired, remove from localStorage
            localStorage.removeItem('hrd-selected-year');
          }
        }
      } catch (error) {
        console.error('Error loading year from localStorage:', error);
        localStorage.removeItem('hrd-selected-year');
      }
      
      // Default to current year if no valid stored year
      dispatch('getTeamData');
    },
  },
};